export const model = {
    id: null,
    order_id: '',
    order_total_price: '',
    patient_name: '',
    service_id: '',
    created_at: '',
    updated_at: ''
};
